import { render } from "./ProcessRegisterTable.vue?vue&type=template&id=5c280da2"
import script from "./ProcessRegisterTable.vue?vue&type=script&lang=js"
export * from "./ProcessRegisterTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__